import { render, staticRenderFns } from "./HeaderBand.vue?vue&type=template&id=bc9085c0&scoped=true&"
import script from "./HeaderBand.vue?vue&type=script&lang=js&"
export * from "./HeaderBand.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBand.vue?vue&type=style&index=0&id=bc9085c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9085c0",
  null
  
)

component.options.__file = "HeaderBand.vue"
export default component.exports